import React, { useState } from 'react';
import {
  MDBCard,
  MDBCardTitle,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBContainer,
} from 'mdbreact';

import Login from './Login';
import AlumniCard from './AlumCard';

const LoginCard = (props) => {
  const [isAlumni, setisAlumni] = useState(false);

  return (
    <MDBContainer className="mt-5 align-content-center">
      <MDBRow center>
        <MDBCol md="6">
          <MDBCard
            className="card-image"
            style={{
              backgroundColor: 'transparent',
            }}
          >
            <div className="text-white text-center rounded border border-dark d-flex align-items-center justify-content-center rgba-black-strong py-5 px-4">
              <div>
                <h5 className="red-text">
                  <MDBIcon icon="clock" />
                  &nbsp;Hours Portal
                </h5>
                <MDBCardTitle
                  tag="h3"
                  className="pt-2"
                  style={{ fontSize: '20px' }}
                >
                  <strong>IITH NSS Hours Portal Login</strong>
                </MDBCardTitle>
                {!isAlumni && (
                  <div>
                    <p>
                      Sign in with your IIT-H Email ID to view your contribution
                      to NSS.
                    </p>
                    <Login />
                    <p>
                      An Alumnus? Click
                      {' '}
                      <a
                        onClick={() => setisAlumni(!isAlumni)}
                        style={{ color: 'red' }}
                      >
                        {' '}
                        here
                      </a>
                    </p>
                  </div>
                )}
                {isAlumni && (
                  <div>
                    <AlumniCard baseURL={props.baseURL} />
                    Not an Alumnus? Click
                    {' '}
                    <a
                      onClick={() => setisAlumni(!isAlumni)}
                      style={{ color: 'red' }}
                    >
                      {' '}
                      here
                    </a>
                  </div>
                )}
              </div>
            </div>
          </MDBCard>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  );
};

export default LoginCard;
